import { UserAvatar } from 'Components/shared/UserAvatar';
import { ChevronRight } from 'lucide-react';
import { PresenceModel } from 'Models/PresenceModel';
import React from 'react';
import { cn } from '~/lib/utils';
import { AVATAR_CONFIG } from '../../utils/avatar_dimensions';
import { ContactSaveAction } from '../ContactDetailsSidebar/components/ContactSaveAction';

interface EntityContactCardProps {
  image?: string;
  name: string;
  subTitle?: string;
  isDestructiveSubtitle?: boolean;
  phoneNumber?: string;
  hasContact?: boolean;
  presence?: PresenceModel;
  isInactive?: boolean;
  isUnsaved?: boolean;
  onNavigateToContact?: () => void;
}

const { size, fontSize } = AVATAR_CONFIG.CONTACT_CARD_DIMENSIONS;

export const EntityContactCard = ({
  image,
  phoneNumber,
  name,
  subTitle,
  isDestructiveSubtitle = false,
  hasContact = false,
  presence,
  isInactive,
  isUnsaved,
  onNavigateToContact,
}: EntityContactCardProps) => {
  if (!hasContact) {
    return <ContactSaveAction contact={phoneNumber} />;
  }

  return (
    <article
      className={cn(
        'p-2 h-[54px] w-full flex flex-row items-center rounded-lg justify-between hover:bg-accent',
        onNavigateToContact && !isInactive && 'cursor-pointer'
      )}
      onClick={!isInactive ? onNavigateToContact : undefined}
    >
      <div className="flex flex-row items-center gap-2.5 overflow-hidden">
        <UserAvatar
          size={size}
          fontSize={fontSize}
          image={image}
          name={isUnsaved ? undefined : name}
          presence={presence}
          isInactive={isInactive}
        />
        <div className="flex flex-col justify-center gap-[2px] overflow-hidden">
          {name && (
            <div className="flex min-w-0 text-[16px]">
              <h4 className="truncate">{name}</h4>
              {isInactive && <span>&nbsp;[Inactive]</span>}
            </div>
          )}
          {subTitle && (
            <p
              className={cn(
                'text-[13px]',
                isDestructiveSubtitle &&
                  'flex items-center justify-center h-[20px] w-fit rounded-md bg-destructive-background px-1 !text-subtitles leading-none text-destructive-light'
              )}
            >
              {subTitle || 'Directory contact'}
            </p>
          )}
        </div>
      </div>
      {onNavigateToContact && !isInactive && (
        <ChevronRight className="size-6 text-muted-foreground shrink-0" />
      )}
    </article>
  );
};
